import * as React from 'react'

import classNames from 'classnames/bind'

import styles from './index.module.css'

const cx = classNames.bind(styles)
interface Props {
  noRadius?: boolean
  noTopRadius?: boolean
  noBorder?: boolean
  expanded?: boolean
  zebra?: boolean
  withTabs?: boolean
  withHeight?: boolean
}

const Table = (props: React.PropsWithChildren<Props>) => {
  const { expanded, zebra, noRadius, noTopRadius, noBorder, children, withTabs, withHeight } = props

  return (
    <div
      className={cx('tableContainer', {
        expanded,
        noBorder,
        withHeight,
      })}
    >
      <table
        className={cx('table', {
          expanded,
          zebra,
          noRadius,
          noTopRadius,
          noBorder,
          withTabs,
        })}
      >
        {children}
      </table>
    </div>
  )
}

export default Table
